<int-integrators-details
        [integrationName]="integrationName"
        [integrationType]="integrationType"
        [creating]="creating"
        [user]="user"
        [invites]="invites"></int-integrators-details>

<div class="content" mat-dialog-content>
  <div *ngIf="creating" class="int-text-container">
    {{description}}
  </div>

  <mat-error *ngIf="authFailed" class="mb-2">
    Failed to link Amazon Seller Central account.<br />
    Be sure that a U.S. Amazon Seller Central account is linked to your Amazon account.
  </mat-error>

  <div fxLayout="row" fxLayoutAlign="center">
    <div *ngIf="existingIntegrations.length === 0 || creating" id="login" (click)="handleLogin($event)">
      <img
              border="0"
              alt="Login with Amazon"
              src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png"
              width="156"
              height="32"
      />
    </div>
  </div>
</div>

<div *ngIf="isAdmin && invites.length > 0">
  <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
</div>

<div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center" class="int-add-container">
  <button mat-stroked-button color="primary" (click)="addAnother($event)">
    <mat-icon>add</mat-icon>
    <span class="center-text">ADD ANOTHER ACCOUNT</span>
  </button>
</div>

<div *ngIf="!noAccounts && !creating">
  <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
    <mat-icon>expand_more</mat-icon>
    <span>SHOW CONNECTED ACCOUNTS</span>
  </button>
  <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
    <mat-icon>expand_less</mat-icon>
    <span>HIDE CONNECTED ACCOUNTS</span>
  </button>
</div>

<div *ngIf="!creating" [hidden]="!showAccounts">
  <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
  <div *ngFor="let int of existingIntegrations">
    Account Name (Profile ID): {{ int.friendlyName ? int.friendlyName : int.profileId }}
  </div>
</div>

<div class="buttons">
  <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="end end">
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>
